import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpItemsService {

  private serviceBaseItems = 'model/items/';

  constructor(private http: HttpClient) { }

  getFilteredItems(filters): Observable<any> {
    return this.http.post(this.serviceBaseItems + 'getFilteredItems', filters);
  }

  getItemById(id): Observable<any> {
    return this.http.post(this.serviceBaseItems + 'getItemById', id);
  }

  getFilteredItemsWithData(id): Observable<any> {
    return this.http.post(this.serviceBaseItems + 'getFilteredItemsWithData', id);
  }

  getGraphsData(filters): Observable<any> {
    return this.http.post(this.serviceBaseItems + 'getGraphsData', filters);
  }

  getTotalItemsCount(): Observable<any> {
    return this.http.get(this.serviceBaseItems + 'getTotalItemsCount');
  }
  getTotalSumGraphData(): Observable<any> {
    return this.http.get(this.serviceBaseItems + 'getTotalSumGraphData');
  }
  getSumsByFieldsGraphData($filters = []): Observable<any> {
    return this.http.post(this.serviceBaseItems + 'getSumsByFieldsGraphData', $filters);
  }
  getCountsByFieldsGraphData($filters = []): Observable<any> {
    return this.http.post(this.serviceBaseItems + 'getCountsByFieldsGraphData', $filters);
  }
  getSumsByCityPartsGraphData(): Observable<any> {
    return this.http.get(this.serviceBaseItems + 'getSumsByCityPartsGraphData');
  }
  getCountsByCityPartsGraphData(): Observable<any> {
    return this.http.get(this.serviceBaseItems + 'getCountsByCityPartsGraphData');
  }

  getEndYearCountGraphData($filters: Array<any> = []): Observable<any> {
    return this.http.post(this.serviceBaseItems + 'getEndYearCountGraphData', $filters);
  }

  getFrontCurrentlyRealized(): Observable<any> {
    return this.http.get(this.serviceBaseItems + 'getFrontCurrentlyRealized');
  }
}
